export const maxItemPerPage = 5;
